import { Action } from "redux";
import { IClientProjectListActionCreator } from "../action/client_projects_action";

import {
  CopyProjectRequest,
  GetAllProjectListByClientRequest,
} from "../request/project_request";

interface IClientProjectListDispatcher {
  getAllByClientProjectList(item: GetAllProjectListByClientRequest): void;
  copy(item: CopyProjectRequest): void;
}

class Dispatcher implements IClientProjectListDispatcher {
  constructor(
    private dispatch: (action: Action) => void,
    private actionCreator: IClientProjectListActionCreator
  ) {}

  public getAllByClientProjectList = (
    item: GetAllProjectListByClientRequest
  ): void => {
    this.dispatch(
      this.actionCreator.requestGetAllByClientProjectListAction(item)
    );
  };

  public copy = (item: CopyProjectRequest): void => {
    this.dispatch(this.actionCreator.requestCopyProjectAction(item));
  };
}

const createClientProjectListDispatcher = (
  dispatch: (action: Action) => void,
  actionCreator: IClientProjectListActionCreator
): IClientProjectListDispatcher => {
  return new Dispatcher(dispatch, actionCreator);
};

export { createClientProjectListDispatcher, IClientProjectListDispatcher };



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_projects_dispatcher.ts